(() => {
  'use strict';

  class BundleBox {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-bundle-config]').textContent);
      this.isSubmitting = false;
      this.bindEvents();
      this.initHeroCTAs();
    }

    bindEvents() {
      this.root.querySelectorAll('.lp-bundle-box-card__btn').forEach(btn => {
        btn.addEventListener('click', () => this.handleBuy(btn));
      });
    }

    async handleBuy(btn) {
      if (this.isSubmitting || btn.disabled) return;

      const card = btn.closest('[data-variant-id]');
      const variantId = parseInt(card.dataset.variantId, 10);
      const supplyKey = card.dataset.supplyKey;

      btn.disabled = true;
      this.isSubmitting = true;

      try {
        const properties = { '_five-reason-why-landing': true };
        if (supplyKey) properties['_five-reason-why-supply'] = supplyKey;

        await this.postJSON('/cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties }]
        });

        await this.reconcileFreeGifts();
        window.location.href = '/checkout';
      } catch (err) {
        console.error('[BundleBox] add to cart failed', err);
        btn.disabled = false;
        this.isSubmitting = false;
      }
    }

    async reconcileFreeGifts() {
      const { gift2m, gift3m } = this.config;
      if (!gift2m && !gift3m) return;

      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      }).then(r => r.json());

      // Collect supply variant IDs from the rendered cards
      const supplyVariantIds = {};
      this.root.querySelectorAll('[data-variant-id][data-supply-key]').forEach(card => {
        const key = card.dataset.supplyKey;
        const id = parseInt(card.dataset.variantId, 10);
        if (key) supplyVariantIds[key] = id;
      });

      const has3m = cart.items.some(i => i.variant_id === supplyVariantIds['3m']);
      const has2m = cart.items.some(i => i.variant_id === supplyVariantIds['2m']);

      // 3m takes priority over 2m; guard against unconfigured (0) gift IDs
      const targetGift = (has3m && gift3m) ? gift3m : ((has2m && gift2m) ? gift2m : null);

      // Remove any gift that should not be in the cart
      const updates = {};
      cart.items.forEach(item => {
        if (
          ((gift2m && item.variant_id === gift2m) || (gift3m && item.variant_id === gift3m)) &&
          item.variant_id !== targetGift
        ) {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length) {
        await this.postJSON('/cart/update.js', { updates });
      }

      // Add the correct gift if it is not already present
      if (targetGift && !cart.items.some(i => i.variant_id === targetGift)) {
        const tier = targetGift === gift3m ? '3m' : '2m';
        await this.postJSON('/cart/add.js', {
          items: [{
            id: targetGift,
            quantity: 1,
            properties: {
              '_five-reason-why-landing': true,
              '_five-reason-why-free-gift-landing': true,
              '_five-reason-why-free-gift': tier
            }
          }]
        });
      }
    }

    initHeroCTAs() {
      const rids = this.config.heroCTARids || [];

      const scrollToSection = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const top = this.root.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top, behavior: 'smooth' });
      };

      rids.forEach(rid => {
        if (!rid) return;
        const btn = document.querySelector(`[data-rid="${rid}"]`);
        if (!btn) return;
        btn.addEventListener('touchend', scrollToSection, { capture: true, passive: false });
        btn.addEventListener('click', scrollToSection, { capture: true });
      });
    }

    async postJSON(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error(`[BundleBox] ${url} failed: ${res.status}`);
      return res.json();
    }
  }

  const init = () => {
    document.querySelectorAll('.js-lp-bundle-box').forEach(el => new BundleBox(el));
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
